import {
  List, Datagrid, TextField, EditButton, Edit, Create, SimpleForm,
  TextInput, NumberInput, required,
} from 'react-admin';
import { Stack } from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import { ImageUploadInput } from '../../components/ImageUploadInput.jsx';

const FacultyList = () => (
  <List sort={{ field: 'sortOrder', order: 'ASC' }} perPage={25}>
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="name" />
      <TextField source="role" />
      <TextField source="subject" />
      <TextField source="joinedYear" label="Joined" />
      <EditButton />
    </Datagrid>
  </List>
);

const FacultyForm = () => (
  <Stack spacing={2} sx={{ maxWidth: 720 }}>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextInput source="name" validate={required()} fullWidth />
      <TextInput source="role" label="Title / role" fullWidth />
    </Stack>
    <ImageUploadInput source="photo" label="Photo" />
    <TextInput source="qualifications" fullWidth helperText="e.g. M.Sc. (Mathematics), University of Dhaka" />
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextInput source="subject" fullWidth />
      <NumberInput source="joinedYear" label="Joined year" />
      <NumberInput source="sortOrder" defaultValue={0} />
    </Stack>
  </Stack>
);

const FacultyEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm><FacultyForm /></SimpleForm>
  </Edit>
);
const FacultyCreate = () => (
  <Create redirect="list">
    <SimpleForm><FacultyForm /></SimpleForm>
  </Create>
);

export default {
  list: FacultyList,
  edit: FacultyEdit,
  create: FacultyCreate,
  icon: GroupsIcon,
  options: { label: 'Faculty' },
  recordRepresentation: 'name',
};
